import { createSelector } from 'reselect';
import { values } from 'lodash-es';
import { getRecordData } from 'utils/tools';

const getRawReferenceResource = (state, props) =>
  state.reference[props.resource];
const getRawReferenceLoading = (state, props) =>
  state.reference[props.resource];
const getReferenceDataSource = (state, props) =>
  getRecordData(props.record, props.source);
const getRawReferenceByResourceName = (state, resource) =>
  state.reference[resource];

export const getReferenceInputResource = createSelector(
  [getRawReferenceResource],
  (references = {}) => {
    const { inputData, data } = references;
    const formattedData = { ...inputData, ...data };
    return values(formattedData);
  },
);

export const getReferenceResourceData = createSelector(
  [getRawReferenceResource],
  (references = {}) => references,
);

export const getReferenceResource = createSelector(
  [getRawReferenceResource],
  (references = { data: {}, ids: [] }) => values(references.data),
);

export const getReferenceArr = createSelector(
  [getRawReferenceResource],
  (resources = { data: {}, ids: [] }) => {
    const { data, ids } = resources;
    return ids.map((id) => data[id]);
  },
);

export const getReferenceArrByResourceName = createSelector(
  [getRawReferenceByResourceName],
  (resources = { data: {}, ids: [] }) => {
    const { data, ids } = resources;
    return ids.map((id) => data[id]);
  },
);
export const getReferenceLoading = createSelector(
  [getRawReferenceLoading],
  (resources = { loading: false }) => {
    const { loading } = resources;
    return loading;
  },
);

export const getReferenceData = createSelector(
  [getRawReferenceResource, getReferenceDataSource],
  (resources = { data: {}, ids: [] }, dataSource) => {
    const { data } = resources;
    return Array.isArray(dataSource)
      ? dataSource.map((id) => data[id])
      : data[`${dataSource}`];
  },
);

export const getTotalReference = createSelector(
  [getRawReferenceResource],
  (resources = { total: 0 }) => {
    const { total } = resources;
    return total;
  },
);

export const getEnabledLoadMoreReference = createSelector(
  [getRawReferenceResource],
  (resources = { total: 0 }) => {
    const { page, loading, numberOfPages } = resources;
    return !loading && page < numberOfPages;
  },
);

export const getEnabledLoadMoreReferenceV2 = createSelector(
  [getRawReferenceResource],
  (resources = { total: 0 }) => {
    const { page, loading, total, size } = resources;
    return !loading && page < Math.ceil(total / size);
  },
);
